import React, { useEffect, useState } from "react";
import { Select, Button, Skeleton, Modal } from "antd";
import { useQuery } from "react-query";
import { getBusinessAccount } from "../../lien-paiement/service/api";
import { PlusCircleOutlined } from "@ant-design/icons";
import { CreateWebhookForm } from "./createWebhookForm";

export const HeaderPart = ({ selectedBusinessAccount, changeBusinessAccount }) => {

    // Variable de session
    const currentUser = JSON.parse(sessionStorage.getItem('authUser'));
    const merchantId = currentUser?.user?.id ||currentUser?.user?.merchantId;

    // State variables
    const [showCreateModal, setShowCreateModal] = useState(false);

    // Query for getting business account list
    const { data: businessAccountList, isLoading, error: businessAccountError } = useQuery({
        queryKey: ['businessAccounts', merchantId, currentUser.token],
        queryFn: getBusinessAccount
    });

    const businessAccounts = businessAccountList || [];

    useEffect(() => {
        changeBusinessAccount(businessAccounts[0]?.id);
    }, [businessAccounts]);

    return (
        <div className="page-header">
            <div className='title-page mb-3'>
                Webhooks
            </div>
            <div className="col-12 col-md-4">
                {
                    !isLoading && !businessAccountError && (
                        <Select
                            size="middle"
                            onChange={(value) => {
                                businessAccounts.forEach((businessAccount) => {
                                    if (businessAccount.id == value) {
                                        changeBusinessAccount(businessAccount.id);
                                    }
                                });
                            }}
                            className="col-7"
                            defaultValue={localStorage.getItem("businessId") ?
                                localStorage.getItem("businessId").toString() :
                                businessAccounts[0].id.toString()}
                            options={
                                Array.isArray(businessAccounts)
                                    ? businessAccounts.map((businessAccount) => ({
                                        value: businessAccount.id.toString(),
                                        label: businessAccount.businessName,
                                    }))
                                    : []
                            }

                        />
                    )

                }
                {
                    isLoading && <Skeleton.Input
                        active
                        size="default"
                        style={{ width: 200 }}
                    />
                }
                {
                    businessAccountError && <Skeleton.Input
                        disabled
                        size="default"
                        style={{ width: 200 }}
                    />
                }

            </div>
            <div className="mt-4">
                <Button
                    className="table-btn"
                    onClick={() => setShowCreateModal(!showCreateModal)}
                >
                    <PlusCircleOutlined /> Configurer un webhook
                </Button>
            </div>

            <Modal
                title="Création d'un webhook"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={showCreateModal}
                onOk={() => setShowCreateModal(false)}
                onCancel={() => setShowCreateModal(false)}
                footer={false}
                bodyStyle={{ padding: 0, width: 400 }}
            >
                <CreateWebhookForm businessAccountId={selectedBusinessAccount} createModal={setShowCreateModal} style={{ width: "100%" }} />
            </Modal>
        </div>
    );
}